import { render, staticRenderFns } from "./TagsMain.vue?vue&type=template&id=5710677a&"
import script from "./TagsMain.vue?vue&type=script&lang=js&"
export * from "./TagsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports